export enum PeriodFilter {
    WEEK = 'Past week',
    MONTH = 'Past month',
    YEAR = 'Past year'
}
export interface ActionHistoryDTO {
    actionType: string;
    changes: {id: number, changeType: string}[]
    entityTitle: string;
    id: number;
    time: string;
    userId: number;
    entityId: number;
    userFullname: string;
}